export default __webpack_public_path__ + "static/media/email-group.90ccd5d3.svg";